import { defineMessages } from "react-intl";

export const checkoutErrorMessages = defineMessages({
  "paymentTerminalId/NOT_FOUND": {
    defaultMessage: "The selected terminal couldn't be found.",
  },
  "paymentTerminalId/required": {
    defaultMessage:
      "Not connected to a terminal. Please connect to one in the settings and try again.",
  },
});
